var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmoothMoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2846 24.8154C32.7191 25.8014 25.448 33.8605 25.448 43.4767H38.4756V41.6219C38.4756 38.3965 40.8205 35.7188 43.8986 35.2006V25.7224C43.8986 25.1483 43.402 24.7002 42.8309 24.7591L42.2846 24.8154ZM38.4728 45.4823H25.4475V61.4654C25.4475 72.2548 34.194 81.0013 44.9835 81.0013C55.7729 81.0013 64.5194 72.2548 64.5194 61.4654V45.4823H51.4967V47.3349C51.4967 50.9313 48.5812 53.8468 44.9848 53.8468C41.3883 53.8468 38.4728 50.9313 38.4728 47.3349V45.4823ZM44.9807 37.1025C42.5831 37.1025 40.6394 39.0462 40.6394 41.4438V47.4049C40.6394 49.8025 42.5831 51.7462 44.9807 51.7462C47.3784 51.7462 49.322 49.8025 49.322 47.4049V41.4438C49.322 39.0462 47.3784 37.1025 44.9807 37.1025Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6872 24.8115C57.2527 25.7975 64.5239 33.8566 64.5239 43.4728H51.4948V41.618C51.4948 38.3931 49.1506 35.7157 46.0732 35.1969V25.7185C46.0732 25.1444 46.5699 24.6963 47.141 24.7552L47.6872 24.8115Z",
    fill: "#FF744E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8472 43.4728H51.5003V41.618C51.5003 38.3931 49.1561 35.7157 46.0787 35.1969V30.0481C47.7279 28.179 50.1412 27 52.8298 27C53.7254 27 54.5905 27.1308 55.4069 27.3744C57.7594 28.7846 59.769 30.6924 61.2984 32.9458C61.6423 33.8994 61.8298 34.9278 61.8298 36C61.8298 39.1129 60.2494 41.8567 57.8472 43.4728Z",
    fill: "#FFD5CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0985 17.9506L25.5547 14.1791C25.223 14.0133 25.223 13.54 25.5546 13.3742L33.0984 9.60181C33.3976 9.45219 33.7497 9.66976 33.7497 10.0043V12.652H56.2436V10.005C56.2436 9.67052 56.5957 9.45295 56.8949 9.60253L64.4386 13.374C64.7703 13.5398 64.7703 14.0131 64.4387 14.1789L56.8949 17.9513C56.5957 18.1009 56.2436 17.8833 56.2436 17.5488V14.902H33.7497V17.5481C33.7497 17.8826 33.3977 18.1001 33.0985 17.9506Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothMoveIcon);
export default __webpack_public_path__ + "static/media/smoothMoveIcon.29f6cfa4e74efa9cfe20f4204c8e0979.svg";
export { ForwardRef as ReactComponent };